module.exports = __webpack_public_path__ + "img/cube6.17b3df88.png";